import React, { useState } from "react";
import { Col, Card, CardBody, Collapse } from "reactstrap";
import { FiTable, FiChevronUp, FiChevronDown } from "react-icons/fi";

const TableSection = ({ title, header, data, hideTableHeader = false }) => {
  const headerStyle = {
    background: "#ebd826",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };

  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen((o) => !o);

  const formatCell = (key, value, rowData) => {
    if (
      key === "montant" ||
      key === "montant_2" ||
      key === "montant_ht" ||
      key === "prime_emission" ||
      key === "valeur_action" ||
      key === "montant_souscrit" ||
      key === "investissements_"
    ) {
      return (
        value?.toLocaleString("fr-FR", {
          style: "currency",
          currency: "EUR",
        }) || "--"
      );
    }

    if (key === "pourcentage" || key === "pourcentage_2") {
      return (
        value
          ?.toLocaleString("fr-FR", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
          .replace("€", "") || "--"
      );
    }

    if (key === "investissement_id" && rowData.investissement_link) {
      return (
        <a
          href={rowData.investissement_link}
          style={{ textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {value}
        </a>
      );
    }

    if (value == null) return "--";
    return value;
  };

  return (
    <Col sm="12">
      <Card
        className="shadow-sm border-0 overflow-hidden mb-4"
        style={{ borderRadius: "12px" }}
      >
        {/* En‑tête cliquable */}
        <div
          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
          style={{
            background: "#555B21",
            letterSpacing: "0.5px",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={toggle}
        >
          <div className="d-flex align-items-center">
            <span style={{ fontSize: "0.82rem" }}>{title}</span>
          </div>
          {isOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
        </div>

        <Collapse isOpen={isOpen}>
          <CardBody className="p-2">
            <div className="table-responsive">
              <table className="table table-bordered rounded-3 overflow-hidden">
                {!hideTableHeader && (
                  <thead>
                    <tr>
                      {header.map((columnName, index) => (
                        <th
                          className="text-nowrap"
                          style={headerStyle}
                          key={index}
                        >
                          {columnName}
                        </th>
                      ))}
                    </tr>
                  </thead>
                )}
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={header.length}>Aucune donnée à afficher</td>
                    </tr>
                  ) : (
                    data.map((rowData, index) => (
                      <tr key={index}>
                        {Object.entries(rowData).map(([key, value]) =>
                          key !== "index" &&
                          key !== "id" &&
                          key !== "investissement_link" ? (
                            <td
                              key={key}
                              className={
                                typeof value === "number" ||
                                key === "position_signature"
                                  ? "text-end"
                                  : ""
                              }
                            >
                              {formatCell(key, value, rowData)}
                            </td>
                          ) : null
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};

export default TableSection;
